module.exports = __webpack_public_path__ + "img/hr_wechat.c5c2a444.png";